import { theme } from '@frameio/vapor';

type RefreshChipAnimation = {
  targetWidth: number;
};

export const refreshChipAnimation = ({
  targetWidth,
}: RefreshChipAnimation) => ({
  initial: {
    y: 0,
    x: '-50%',
    opacity: 0,
  },
  animate: {
    transition: { duration: 0.25, ease: theme.transitions.curves.primary },
    y: '8px',
    x: '-50%',
    opacity: 1,
    width: targetWidth,
  },
  exit: {
    transition: {
      opacity: { duration: 0.2, ease: theme.transitions.curves.primary },
      y: { duration: 0.2, ease: theme.transitions.curves.fastStart },
      x: { duration: 0.2, ease: theme.transitions.curves.fastStart },
      width: { duration: 0.2, ease: theme.transitions.curves.primary },
    },
    y: 0,
    x: '-50%',
    opacity: 0,
  },
});

export const crossFade = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.2, ease: theme.transitions.curves.primary },
};
